/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
export type TradeFirmLoyaltyStatus = "BLACKLISTED" | "ELIGIBLE" | "ENROLLED" | "NOT_ELIGIBLE" | "%future added value";
import type { FragmentReference } from "relay-runtime";
declare export opaque type EnrollCta_tradeFirm$ref: FragmentReference;
export type EnrollCta_tradeFirm = {|
  +loyalty: ?{|
    +status: ?TradeFirmLoyaltyStatus
  |},
  +$refType: EnrollCta_tradeFirm$ref,
|};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "EnrollCta_tradeFirm",
  "type": "TradeFirmType",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "loyalty",
      "storageKey": null,
      "args": null,
      "concreteType": "TradeFirmLoyaltyType",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "status",
          "args": null,
          "storageKey": null
        }
      ]
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '055fe19d226751ea167ece1cab42a6f1';
module.exports = node;
